export default {
  // Navigation
  nav_home: "Home",
  nav_intro: "Introductie",
  nav_components: "Componenten",
  nav_operation: "Werking",
  nav_problems: "Storingen",
  nav_diagnosis: "Diagnose",
  nav_engineer: "Site Engineer",
  nav_safety: "Veiligheid",
  nav_electrical: "Elektrisch Schakelen",
  nav_quiz1: "Quiz 1",
  nav_quiz2: "Quiz 2",
  nav_quiz3: "Quiz 3",
  nav_quiz_logistiek: "Quiz Logistiek",

  // Home Page
  home_title: "Geautomatiseerde Logistieke Systemen",
  home_subtitle: "Professionele training voor BEUMER Group systemen",
  home_welcome: "Welkom bij de cursus",
  home_description: "Deze cursus behandelt geautomatiseerde logistieke systemen gebruikt bij PostNL, DHL, Bol.com en op vliegvelden. Leer over transport, sortering, barcode scanning en onderhoud.",
  home_start: "Start de cursus",
  home_modules: "Cursusmodules",
  home_quizzes: "Test je kennis",

  // Introduction Page
  intro_title: "Introductie tot Geautomatiseerde Logistieke Systemen",
  intro_description: "Geautomatiseerde logistieke systemen worden gebruikt bij PostNL, DHL, Bol.com en op vliegvelden. Deze systemen zorgen voor:",
  intro_feature1: "Transport van pakketten",
  intro_feature2: "Automatische sortering",
  intro_feature3: "Uitlezing van barcodes",
  intro_feature4: "Distributie naar de juiste bestemming",
  intro_feature5: "Continue monitoring",
  intro_beumer: "BEUMER Group ontwerpt, bouwt en onderhoudt deze systemen.",

  // Components Page
  comp_title: "Hoofdonderdelen van een Logistiek Systeem",
  comp_conveyor: "Transportband (Conveyor)",
  comp_conveyor_desc: "De transportband verplaatst pakketten automatisch.",
  comp_conveyor_parts: "Belangrijke onderdelen:",
  comp_motor: "Motor",
  comp_inverter: "Inverter/drive",
  comp_rollers: "Rollen",
  comp_bearings: "Lagers",
  comp_belt: "Band (belt)",
  comp_sensors: "Sensoren",
  comp_safety: "Veiligheidsbeveiligingen",
  comp_plc_control: "PLC-besturing",
  
  comp_plc_title: "Wat is een PLC?",
  comp_plc_def: "Een PLC (Programmable Logic Controller) is de computer die het hele systeem aanstuurt.",
  comp_plc_functions: "Functies van de PLC:",
  comp_plc_func1: "Ontvangt signalen van sensoren",
  comp_plc_func2: "Stuurt motoren en actuatoren aan",
  comp_plc_func3: "Verwerkt foutcodes",
  comp_plc_func4: "Regelt snelheid van de band",
  comp_plc_func5: "Beheert veiligheid en noodstops",
  comp_plc_func6: "Coördineert het complete sorteersysteem",
  comp_plc_note: "Zonder PLC functioneert het systeem niet.",

  comp_sensors_title: "Sensoren",
  comp_sensors_desc: "Veelgebruikte sensoren:",
  comp_sensor1: "Fotocel → detecteert pakket",
  comp_sensor2: "Proximity sensor → detecteert metaal",
  comp_sensor3: "Barcode scanner → leest etiketten",
  comp_sensor4: "Laser scanner → meet formaat/positie",
  comp_sensor5: "Noodstop sensoren",
  comp_sensors_note: "Sensoren geven informatie door aan de PLC.",

  comp_motors_title: "Motoren & Drives",
  comp_motor_desc: "Motor: zorgt voor de beweging van de band.",
  comp_drive_desc: "Drive (inverter): regelt snelheid, richting en koppel.",

  comp_mechanical_title: "Mechanische Onderdelen",
  comp_mech1: "Rollen",
  comp_mech2: "Lagers",
  comp_mech3: "Aandrijving",
  comp_mech4: "Bandspanning",
  comp_mech5: "Geleidingen",
  comp_mech6: "Frame en constructie",
  comp_mech_note: "Mechanische slijtage is normaal → regelmatig onderhoud is essentieel.",

  // Operation Page
  oper_title: "Werking van het Systeem",
  oper_subtitle: "Stap voor stap proces",
  oper_step1: "Sensor detecteert een pakket",
  oper_step2: "PLC ontvangt het signaal",
  oper_step3: "Motor start → band beweegt",
  oper_step4: "Scanner leest barcode",
  oper_step5: "PLC bepaalt de route",
  oper_step6: "Sorteermechanisme stuurt pakket naar de juiste uitgang",
  oper_step7: "Systeem monitort fouten en veiligheid",

  // Problems Page
  prob_title: "Veelvoorkomende Storingen en Oplossingen",
  prob_jammed: "Pakket Vastgelopen",
  prob_jammed_cause: "Oorzaak: pakket ligt scheef of zit fysiek vast.",
  prob_jammed_solution: "Oplossing:",
  prob_jammed_sol1: "Machine veilig stoppen",
  prob_jammed_sol2: "Pakket verwijderen",
  prob_jammed_sol3: "Controle uitvoeren",
  prob_jammed_sol4: "Systeem opnieuw starten",

  prob_sensor: "Sensorstoring",
  prob_sensor_cause: "Oorzaak: sensor vuil, verschoven, kabel los.",
  prob_sensor_solution: "Oplossing:",
  prob_sensor_sol1: "Schoonmaken",
  prob_sensor_sol2: "Kabels vastzetten",
  prob_sensor_sol3: "Sensor correct richten",
  prob_sensor_sol4: "Test uitvoeren in het display",

  prob_mechanical: "Mechanische Storing",
  prob_mech_examples: "Voorbeelden:",
  prob_mech_ex1: "Band te los of scheef",
  prob_mech_ex2: "Rol defect",
  prob_mech_ex3: "Lager versleten",
  prob_mech_ex4: "Aandrijving maakt geluid",
  prob_mech_solution: "Oplossing:",
  prob_mech_sol1: "Bandspanning controleren",
  prob_mech_sol2: "Rollen vervangen",
  prob_mech_sol3: "Lagers smeren of vernieuwen",

  prob_electrical: "Elektrische Storing",
  prob_elec_examples: "Voorbeelden:",
  prob_elec_ex1: "Zekering doorgebrand",
  prob_elec_ex2: "Kabelbreuk",
  prob_elec_ex3: "Motor zonder voeding",
  prob_elec_ex4: "Losse verbindingen",
  prob_elec_solution: "Oplossing:",
  prob_elec_sol1: "Spanningsmeting uitvoeren",
  prob_elec_sol2: "Zekeringen controleren",
  prob_elec_sol3: "Kabels en connectors nalopen",

  prob_plc: "PLC of Software Storing",
  prob_plc_examples: "Voorbeelden:",
  prob_plc_ex1: "Foutcode in het PLC-scherm",
  prob_plc_ex2: "Sensor zonder signaal",
  prob_plc_ex3: "Communicatiestoringen",
  prob_plc_solution: "Oplossing:",
  prob_plc_sol1: "Foutcode lezen",
  prob_plc_sol2: "Reset uitvoeren",
  prob_plc_sol3: "Sensor/motor status controleren",
  prob_plc_sol4: "Indien nodig service engineer bellen",

  // Diagnosis Page
  diag_title: "Diagnose Stappenplan",
  diag_subtitle: "Professionele aanpak",
  diag_step1: "Rustig blijven",
  diag_step2: "Foutcode lezen op display",
  diag_step3: "Visuele inspectie",
  diag_step4: "Sensoren testen",
  diag_step5: "Motor en band controleren",
  diag_step6: "Systeem veilig resetten",
  diag_step7: "Oorzaak vastleggen",
  diag_step8: "Preventieve actie ondernemen",

  // Engineer Page
  eng_title: "De Rol van een Site Engineer",
  eng_description: "Een Site Engineer zorgt voor:",
  eng_resp1: "Continuïteit van het proces",
  eng_resp2: "Oplossen van storingen",
  eng_resp3: "Preventief onderhoud",
  eng_resp4: "Communicatie met operators",
  eng_resp5: "Uitvoeren van veiligheidsprocedures",
  eng_resp6: "Basis elektrische en mechanische werkzaamheden",
  eng_resp7: "Werken in ploegendienst",
  eng_resp8: "Veilig werken (VCA)",
  eng_qualities: "Belangrijke eigenschappen:",
  eng_qual1: "Rustig",
  eng_qual2: "Nauwkeurig",
  eng_qual3: "Veiligheidsbewust",
  eng_qual4: "Probleemoplossend",
  eng_qual5: "Leergierig",
  eng_qual6: "Samenwerkend",

  // Safety Page
  safety_title: "Veilig Werken",
  safety_subtitle: "Belangrijkste onderdeel",
  safety_description: "Veilig werken betekent:",
  safety_rule1: "Altijd spanning uitschakelen",
  safety_rule2: "\"Meten is weten\": spanning testen",
  safety_rule3: "PBM's dragen",
  safety_rule4: "Lock-out / Tag-out toepassen",
  safety_rule5: "Nooit onder druk werken",
  safety_rule6: "Risico's herkennen",

  // Quiz Common
  quiz_submit: "Indienen",
  quiz_retry: "Opnieuw proberen",
  quiz_score: "Je score:",
  quiz_correct: "correct van",
  quiz_excellent: "Uitstekend! Je beheerst de stof goed.",
  quiz_good: "Goed gedaan! Je hebt de basis onder de knie.",
  quiz_review: "Bekijk de cursus nog eens en probeer opnieuw.",

  // Quiz 1
  quiz1_title: "Quiz 1: Fundamenten",
  quiz1_q1: "Wat is de hoofdfunctie van een geautomatiseerd logistiek systeem?",
  quiz1_q1_a: "Pakketten handmatig sorteren",
  quiz1_q1_b: "Automatisch transport en sortering van pakketten",
  quiz1_q1_c: "Alleen barcodes scannen",
  
  quiz1_q2: "Welke bedrijven gebruiken geautomatiseerde logistieke systemen?",
  quiz1_q2_a: "Alleen PostNL",
  quiz1_q2_b: "PostNL, DHL, Bol.com en vliegvelden",
  quiz1_q2_c: "Alleen vliegvelden",

  quiz1_q3: "Wat doet BEUMER Group?",
  quiz1_q3_a: "Alleen onderhoud",
  quiz1_q3_b: "Ontwerpen, bouwen en onderhouden van logistieke systemen",
  quiz1_q3_c: "Alleen software ontwikkelen",

  quiz1_q4: "Wat is een transportband?",
  quiz1_q4_a: "Een handmatig karretje",
  quiz1_q4_b: "Een systeem dat pakketten automatisch verplaatst",
  quiz1_q4_c: "Een opslagruimte",

  quiz1_q5: "Wat betekent PLC?",
  quiz1_q5_a: "Pakket Logistiek Centrum",
  quiz1_q5_b: "Programmable Logic Controller",
  quiz1_q5_c: "Post Levering Computer",

  quiz1_q6: "Wat is de functie van een PLC?",
  quiz1_q6_a: "Alleen pakketten wegen",
  quiz1_q6_b: "Het hele systeem aansturen en coördineren",
  quiz1_q6_c: "Alleen barcodes printen",

  quiz1_q7: "Welke sensor detecteert een pakket op de band?",
  quiz1_q7_a: "Temperatuursensor",
  quiz1_q7_b: "Fotocel",
  quiz1_q7_c: "Druksensor",

  quiz1_q8: "Wat leest een barcode scanner?",
  quiz1_q8_a: "Temperatuur",
  quiz1_q8_b: "Etiketten op pakketten",
  quiz1_q8_c: "Gewicht",

  // Quiz 2
  quiz2_title: "Quiz 2: Componenten en Werking",
  quiz2_q1: "Wat regelt een drive (inverter)?",
  quiz2_q1_a: "Alleen de kleur van de band",
  quiz2_q1_b: "Snelheid, richting en koppel van de motor",
  quiz2_q1_c: "Alleen de temperatuur",

  quiz2_q2: "Welk onderdeel zorgt voor de beweging van de band?",
  quiz2_q2_a: "Sensor",
  quiz2_q2_b: "Motor",
  quiz2_q2_c: "PLC scherm",

  quiz2_q3: "Wat is mechanische slijtage?",
  quiz2_q3_a: "Een softwarefout",
  quiz2_q3_b: "Normale slijtage van bewegende delen die regelmatig onderhoud vereist",
  quiz2_q3_c: "Een elektrische storing",

  quiz2_q4: "Wat is de eerste stap in de werking van het systeem?",
  quiz2_q4_a: "Motor start",
  quiz2_q4_b: "Sensor detecteert een pakket",
  quiz2_q4_c: "Barcode wordt geprint",

  quiz2_q5: "Wat gebeurt er nadat de scanner de barcode leest?",
  quiz2_q5_a: "Het systeem stopt",
  quiz2_q5_b: "PLC bepaalt de route",
  quiz2_q5_c: "Het pakket wordt gewogen",

  quiz2_q6: "Wat doet het sorteermechanisme?",
  quiz2_q6_a: "Pakketten wegen",
  quiz2_q6_b: "Pakketten naar de juiste uitgang sturen",
  quiz2_q6_c: "Barcodes printen",

  quiz2_q7: "Welke informatie geven sensoren door?",
  quiz2_q7_a: "Alleen temperatuur",
  quiz2_q7_b: "Signalen naar de PLC",
  quiz2_q7_c: "Alleen gewicht",

  quiz2_q8: "Wat monitort het systeem continu?",
  quiz2_q8_a: "Alleen de tijd",
  quiz2_q8_b: "Fouten en veiligheid",
  quiz2_q8_c: "Alleen de kleur van pakketten",

  // Quiz 3
  quiz3_title: "Quiz 3: Praktijk en Veiligheid",
  quiz3_q1: "Wat is de eerste stap bij een vastgelopen pakket?",
  quiz3_q1_a: "Pakket er met kracht uittrekken",
  quiz3_q1_b: "Machine veilig stoppen",
  quiz3_q1_c: "Doorgaan met werken",

  quiz3_q2: "Wat kan de oorzaak zijn van een sensorstoring?",
  quiz3_q2_a: "Te veel pakketten",
  quiz3_q2_b: "Sensor vuil, verschoven of kabel los",
  quiz3_q2_c: "Te weinig licht in de ruimte",

  quiz3_q3: "Wat is een voorbeeld van mechanische storing?",
  quiz3_q3_a: "Foutcode op het scherm",
  quiz3_q3_b: "Band te los of scheef",
  quiz3_q3_c: "Internetverbinding verbroken",

  quiz3_q4: "Wat moet je doen bij een doorgebrande zekering?",
  quiz3_q4_a: "Negeren en doorwerken",
  quiz3_q4_b: "Zekering controleren en vervangen",
  quiz3_q4_c: "Systeem opnieuw opstarten zonder controle",

  quiz3_q5: "Wat is de eerste stap in het diagnose stappenplan?",
  quiz3_q5_a: "In paniek raken",
  quiz3_q5_b: "Rustig blijven",
  quiz3_q5_c: "Direct de engineer bellen",

  quiz3_q6: "Wat doet een Site Engineer?",
  quiz3_q6_a: "Alleen koffie halen",
  quiz3_q6_b: "Storingen oplossen en preventief onderhoud uitvoeren",
  quiz3_q6_c: "Alleen administratie",

  quiz3_q7: "Welke eigenschap is belangrijk voor een Site Engineer?",
  quiz3_q7_a: "Ongeduldig",
  quiz3_q7_b: "Veiligheidsbewust",
  quiz3_q7_c: "Onnauwkeurig",

  quiz3_q8: "Wat betekent 'Meten is weten'?",
  quiz3_q8_a: "Altijd een meetlint gebruiken",
  quiz3_q8_b: "Spanning testen voordat je werkt",
  quiz3_q8_c: "Pakketten wegen",

  quiz3_q9: "Wat is Lock-out / Tag-out?",
  quiz3_q9_a: "De deur op slot doen",
  quiz3_q9_b: "Veiligheidsprocedure om spanning uit te schakelen en te markeren",
  quiz3_q9_c: "Een computerprogramma",

  quiz3_q10: "Waarom is veilig werken het belangrijkste onderdeel?",
  quiz3_q10_a: "Om sneller te kunnen werken",
  quiz3_q10_b: "Om ongevallen en letsel te voorkomen",
  quiz3_q10_c: "Om minder pauzes te nemen",

  // Electrical Switching Page
  elec_title: "Elektrisch Schakelen",
  elec_subtitle: "Professionele gids voor technisch personeel, monteurs en Site Engineers",

  // 1. What is electrical switching
  elec_what_title: "1. Wat is Elektrisch Schakelen?",
  elec_what_desc: "Elektrisch schakelen is het openen en sluiten van elektrische circuits om de stroomtoevoer te regelen. Dit is een fundamenteel principe in alle elektrische en geautomatiseerde systemen.",
  elec_examples: "Voorbeelden van schakelen:",
  elec_ex1: "Lichtschakelaar",
  elec_ex2: "Relais",
  elec_ex3: "Contactor",
  elec_ex4: "PLC-uitgang",
  elec_ex5: "Noodstop-knop",
  elec_ex6: "Start/Stop-knoppen",
  elec_closed: "Gesloten Circuit",
  elec_closed_desc: "Stroom kan lopen → apparaat werkt",
  elec_open: "Open Circuit",
  elec_open_desc: "Geen stroom → apparaat staat uit",

  // 2. Basic concepts
  elec_basics_title: "2. Basisbegrippen van Schakelen",
  elec_series: "Serieschakeling",
  elec_series_desc: "Alle schakelaars moeten gesloten zijn voor stroom kan lopen. Als één schakelaar open staat, werkt het circuit niet.",
  elec_parallel: "Parallelschakeling",
  elec_parallel_desc: "Als één van de schakelaars gesloten is, kan de stroom lopen. Meerdere routes mogelijk.",
  elec_no: "NO (Normally Open)",
  elec_no_desc: "Normaal open contact. Sluit alleen wanneer geactiveerd (bijvoorbeeld knop ingedrukt).",
  elec_nc: "NC (Normally Closed)",
  elec_nc_desc: "Normaal gesloten contact. Opent alleen wanneer geactiveerd. Vaak gebruikt voor veiligheid.",

  // 3. Types of switches
  elec_types_title: "3. Soorten Schakelaars",
  elec_type1: "Enkelpolige Schakelaar",
  elec_type1_desc: "Schakelt één circuit aan of uit. Gebruikt voor eenvoudige toepassingen zoals verlichting.",
  elec_type2: "Dubbelpolige Schakelaar",
  elec_type2_desc: "Schakelt twee circuits tegelijk. Gebruikt voor 230V toepassingen waarbij fase en nul geschakeld worden.",
  elec_type3: "Drukknop (NO/NC)",
  elec_type3_desc: "Tijdelijke schakelaar die terugveert. Beschikbaar als NO (opener) of NC (sluitcontact).",
  elec_type4: "Magneetschakelaar / Contactor",
  elec_type4_desc: "Elektromagnetische schakelaar voor zware stromen. Gebruikt voor motoren en grote verbruikers.",
  elec_type5: "Relais",
  elec_type5_desc: "Kleine elektromagnetische schakelaar. Lage stroom stuurt hoge stroom aan.",
  elec_type6: "PLC-uitgangen",
  elec_type6_desc: "Digitale uitgangen van de PLC die andere apparaten aansturen via relais of transistors.",
  elec_type7: "Eindschakelaars",
  elec_type7_desc: "Detecteren positie van bewegende delen. Vaak gebruikt als veiligheidslimiet.",
  elec_type8: "Veiligheidsrelais",
  elec_type8_desc: "Speciale relais voor veiligheidscircuits met geforceerde contactscheiding.",

  // 4. Industrial systems
  elec_industrial_title: "4. Elektrisch Schakelen in Industriële Systemen",
  elec_industrial_desc: "In logistieke systemen zoals bij BEUMER Group wordt elektrisch schakelen gebruikt voor:",
  elec_ind1: "Aansturen van Motoren",
  elec_ind1_desc: "Contactoren schakelen motoren voor transportbanden aan en uit. De PLC stuurt de contactor aan.",
  elec_ind2: "Start/Stop-circuits",
  elec_ind2_desc: "Drukknoppen voor handmatige bediening. Start-knop (NO) en Stop-knop (NC) in serie met veiligheidsketen.",
  elec_ind3: "Sensorcircuits",
  elec_ind3_desc: "Sensoren schakelen signalen naar de PLC. Fotocellen, proximity sensors en scanners.",
  elec_ind4: "Veiligheidsketens",
  elec_ind4_desc: "NC-contacten in serie geschakeld. Als één veiligheidsschakelaar opent, stopt het hele systeem.",
  elec_ind5: "Noodstopbedrading",
  elec_ind5_desc: "Noodstoppen zijn NC-contacten in de veiligheidsketen. Drukken opent het contact en stopt de machine.",
  elec_ind6: "Storingsdetectie via PLC",
  elec_ind6_desc: "PLC monitort alle schakelingen en detecteert fouten zoals sensor uitval of motoroverbelasting.",
  elec_beumer_title: "BEUMER Group Systemen",
  elec_beumer_desc: "Bij BEUMER Group worden complexe schakelschema's gebruikt om transportbanden, sorteersystemen en veiligheidsketens aan te sturen. Site Engineers moeten deze schema's kunnen lezen en storingen kunnen oplossen.",

  // 5. Safety
  elec_safety_title: "5. Veilig Elektrisch Schakelen (VCA-niveau)",
  elec_safety_warning: "⚠️ WAARSCHUWING: Elektriciteit is levensgevaarlijk! Volg altijd de veiligheidsregels.",
  elec_safe1: "Altijd Spanning Uitschakelen",
  elec_safe1_desc: "Schakel de hoofdschakelaar uit voordat je aan elektrische installaties werkt. Controleer alle fasen.",
  elec_safe2: "Meten is Weten",
  elec_safe2_desc: "Test altijd met een multimeter of spanningstester of de spanning echt uit is. Vertrouw niet alleen op schakelaars.",
  elec_safe3: "Lock-out / Tag-out",
  elec_safe3_desc: "Vergrendel de hoofdschakelaar met een slot en hang een waarschuwingslabel. Alleen jij hebt de sleutel.",
  elec_safe4: "PBM's Dragen",
  elec_safe4_desc: "Draag persoonlijke beschermingsmiddelen: veiligheidsschoenen, handschoenen, veiligheidsbril en geïsoleerd gereedschap.",
  elec_safe5: "Nooit Noodstoppen Overbruggen",
  elec_safe5_desc: "Overbruggen van noodstoppen of veiligheidsschakelaars is levensgevaarlijk en strikt verboden.",
  elec_safe6: "Risico's Herkennen",
  elec_safe6_desc: "Let op beschadigde kabels, losse verbindingen, vocht en andere gevaren. Meld gevaarlijke situaties direct.",

  // 6. Common errors
  elec_errors_title: "6. Veelvoorkomende Fouten en Oplossingen",
  elec_error: "FOUT",
  elec_solution: "OPLOSSING",
  elec_err1: "Losse Klemmen",
  elec_err1_sol: "Controleer alle klemmen met een schroevendraaier. Draai losse klemmen vast. Controleer op oxidatie.",
  elec_err2: "Verkeerde Aansluiting NO/NC",
  elec_err2_sol: "Controleer het schakelschema. Meet met multimeter welk contact NO en NC is. Sluit correct aan.",
  elec_err3: "Zekering Doorgebrand",
  elec_err3_sol: "Zoek eerst de oorzaak (kortsluiting, overbelasting). Los het probleem op. Vervang zekering met juiste waarde.",
  elec_err4: "Kabelbreuk",
  elec_err4_sol: "Meet doorgankelijkheid met multimeter. Vervang beschadigde kabel. Controleer kabelgeleiding op scherpe randen.",
  elec_err5: "Sensor Werkt Niet",
  elec_err5_sol: "Reinig de sensor. Controleer voedingsspanning. Test met PLC-display. Controleer afstand en uitlijning.",
  elec_err6: "Contactor Trekt Niet Aan",
  elec_err6_sol: "Meet spoelspanning. Controleer PLC-uitgang. Reinig contacten. Vervang defecte contactor.",

  // 7. Practice exercises
  elec_practice_title: "7. Praktische Oefeningen",
  elec_practice_desc: "Test je kennis met deze praktijkvragen:",
  elec_q1: "Wat gebeurt er als een NC-sensor open blijft staan?",
  elec_q1_a: "Het systeem start automatisch",
  elec_q1_b: "Het systeem kan niet starten (veiligheidsketen onderbroken)",
  elec_q1_c: "Niets, het systeem werkt normaal",
  elec_q2: "Wat controleer je eerst bij een motor die niet start?",
  elec_q2_a: "De kleur van de motor",
  elec_q2_b: "Of de motor nieuw is",
  elec_q2_c: "Spanning op de contactor, PLC-uitgang, noodstop-positie en zekeringen",
  elec_q3: "Waarom wordt een contactor gebruikt in plaats van een gewone schakelaar?",
  elec_q3_a: "Een contactor kan hoge stromen schakelen en wordt op afstand aangestuurd",
  elec_q3_b: "Een contactor is goedkoper",
  elec_q3_c: "Een contactor ziet er mooier uit",
  elec_check: "Controleer Antwoorden",
  elec_retry: "Opnieuw Proberen",
  elec_perfect: "Perfect! Alle antwoorden correct!",
  elec_good: "Goed gedaan!",
  elec_try_again: "Probeer het nog eens",
  elec_score_text: "Je hebt {score} van de {total} vragen goed beantwoord.",

  // 8. Summary
  elec_summary_title: "8. Samenvatting",
  elec_sum1: "Elektrisch schakelen is het openen en sluiten van circuits om stroom te regelen",
  elec_sum2: "NO (Normally Open) sluit bij activering, NC (Normally Closed) opent bij activering",
  elec_sum3: "Serieschakeling: alle schakelaars moeten gesloten zijn. Parallelschakeling: één schakelaar gesloten is genoeg",
  elec_sum4: "Verschillende schakelaars: enkelpolig, dubbelpolig, drukknoppen, contactoren, relais, PLC-uitgangen",
  elec_sum5: "In industriële systemen worden schakelingen gebruikt voor motoren, sensoren, veiligheid en noodstoppen",
  elec_sum6: "Veiligheid is het belangrijkste: spanning uitschakelen, meten, Lock-out/Tag-out, PBM's dragen",
  elec_sum7: "Veelvoorkomende fouten: losse klemmen, verkeerde aansluitingen, doorgebrande zekeringen, kabelbreuken",
  elec_sum8: "Als Site Engineer moet je schakelschema's kunnen lezen en elektrische storingen kunnen oplossen",
  elec_final_message: "Elektrisch schakelen is een fundamentele vaardigheid voor elke Site Engineer. Veiligheid staat altijd voorop!",

  // Onderhoudstechniek page
  maint_title: 'Onderhoudstechniek',
  maint_subtitle: 'Professionele technieken voor het onderhouden van logistieke systemen, machines en installaties',
  
  maint_what_title: 'Wat is onderhoudstechniek?',
  maint_what_desc: 'Onderhoudstechniek is een essentieel vakgebied dat zich richt op het in optimale staat houden van machines, installaties en technische systemen. Het doel is om storingen te voorkomen, de betrouwbaarheid te verbeteren en de veiligheid te waarborgen.',
  
  maint_focus1: 'Onderhouden van machines',
  maint_focus1_desc: 'Regelmatig onderhoud aan transportbanden, motoren, lagers en andere mechanische componenten',
  maint_focus2: 'Storingen voorkomen',
  maint_focus2_desc: 'Proactief handelen om defecten te voorkomen voordat ze optreden',
  maint_focus3: 'Betrouwbaarheid verbeteren',
  maint_focus3_desc: 'Systemen optimaliseren voor maximale uptime en prestaties',
  maint_focus4: 'Veilig werken',
  maint_focus4_desc: 'Alle werkzaamheden uitvoeren volgens VCA-normen en veiligheidsprotocollen',
  
  maint_logistics_title: 'Voorbeelden uit logistieke systemen',
  maint_logistics_desc: 'In sorteercentra van PostNL, DHL en Bol.com is onderhoudstechniek cruciaal. Transportbanden moeten dagelijks duizenden pakketten verwerken. Preventief onderhoud aan lagers, rollen en sensoren voorkomt kostbare stilstand en zorgt voor continue operatie.',
  
  maint_types_title: 'Soorten onderhoud',
  
  maint_preventive: 'Preventief onderhoud',
  maint_preventive_desc: 'Gepland onderhoud om storingen te voorkomen',
  maint_prev1: 'Gepland onderhoud volgens schema',
  maint_prev2: 'Smeren van lagers en bewegende delen',
  maint_prev3: 'Vervangen van slijtdelen',
  maint_prev4: 'Periodieke inspecties en controles',
  
  maint_corrective: 'Correctief onderhoud',
  maint_corrective_desc: 'Reparaties na een storing of defect',
  maint_corr1: 'Reparaties na storingen',
  maint_corr2: 'Defecte onderdelen vervangen',
  maint_corr3: 'Diagnose uitvoeren en oplossen',
  
  maint_predictive: 'Predictief onderhoud',
  maint_predictive_desc: 'Onderhoud op basis van sensordata en analyses',
  maint_pred1: 'Sensordata analyseren',
  maint_pred2: 'Trillingsmetingen uitvoeren',
  maint_pred3: 'Temperatuurmetingen monitoren',
  maint_pred4: 'Vroegtijdige foutdetectie',
  
  maint_periodic: 'Periodiek onderhoud',
  maint_periodic_desc: 'Regelmatige controles volgens vast schema',
  maint_per1: 'Wekelijkse controles',
  maint_per2: 'Maandelijkse inspecties',
  maint_per3: 'Jaarlijks groot onderhoud',
  
  maint_components_title: 'Belangrijke onderdelen in onderhoudstechniek',
  
  maint_comp1: 'Motoren (AC/DC)',
  maint_comp1_desc: 'Elektrische aandrijvingen voor transportbanden en machines',
  maint_comp2: 'Lagers',
  maint_comp2_desc: 'Kogellagers en rollagers die bewegende delen ondersteunen',
  maint_comp3: 'Rollen',
  maint_comp3_desc: 'Transportrollen voor bandtransport',
  maint_comp4: 'Transportbanden',
  maint_comp4_desc: 'Rubber of kunststof banden voor goederentransport',
  maint_comp5: 'Aandrijvingen (inverters)',
  maint_comp5_desc: 'Frequentieregelaars voor motorbesturing',
  maint_comp6: 'Sensoren',
  maint_comp6_desc: 'Foto-elektrisch, inductief en laser sensoren',
  maint_comp7: 'Kettingen en tandwielen',
  maint_comp7_desc: 'Mechanische overbrengingen en koppelingen',
  maint_comp8: 'Elektrische bedrading',
  maint_comp8_desc: 'Kabels, schakelkasten en aansluitingen',
  
  maint_diagnosis_title: 'Diagnose en storingsanalyse',
  maint_diagnosis_desc: 'Een systematische aanpak voor het opsporen en oplossen van storingen:',
  
  maint_diag1: 'Foutcode lezen',
  maint_diag1_desc: 'PLC-foutcodes en alarmmeldingen controleren',
  maint_diag2: 'Visuele inspectie',
  maint_diag2_desc: 'Controleren op zichtbare schade, slijtage of afwijkingen',
  maint_diag3: 'Metingen uitvoeren',
  maint_diag3_desc: 'Spanning, weerstand en continuïteit meten met multimeter',
  maint_diag4: 'Sensoren testen',
  maint_diag4_desc: 'Werking van sensoren controleren en signalen meten',
  maint_diag5: 'Motoren controleren',
  maint_diag5_desc: 'Trillingen, temperatuur en geluid van motoren beoordelen',
  maint_diag6: 'Onderdelen demonteren',
  maint_diag6_desc: 'Verdachte componenten uitnemen en inspecteren',
  maint_diag7: 'Oorzaak registreren',
  maint_diag7_desc: 'Storing documenteren in onderhoudslogboek',
  maint_diag8: 'Preventieve maatregelen',
  maint_diag8_desc: 'Acties nemen om herhaling te voorkomen',
  
  maint_procedures_title: 'Onderhoudsprocedures',
  
  maint_proc1: 'Veilig uitschakelen (LOTO)',
  maint_proc1_desc: 'Lock-out/Tag-out procedure toepassen',
  maint_proc2: 'Spanningsvrij werken',
  maint_proc2_desc: 'Spanning uitschakelen en controleren',
  maint_proc3: 'Smeren van lagers',
  maint_proc3_desc: 'Juiste smeermiddelen op juiste plaatsen aanbrengen',
  maint_proc4: 'Transportbanden vervangen',
  maint_proc4_desc: 'Oude band verwijderen en nieuwe band monteren',
  maint_proc5: 'Motoren uitlijnen',
  maint_proc5_desc: 'Motoren en rollen correct positioneren',
  maint_proc6: 'Kettingen spannen',
  maint_proc6_desc: 'Juiste spanning van kettingen en riemen instellen',
  maint_proc7: 'Schoonmaak en inspectie',
  maint_proc7_desc: 'Machines reinigen en controleren',
  maint_proc8: 'Controles uitvoeren',
  maint_proc8_desc: 'Voor- en nacontroles volgens checklist',
  
  maint_safety_title: 'Veiligheid bij onderhoud (VCA)',
  maint_safety_warning: 'Veiligheid heeft altijd prioriteit!',
  maint_safety_warning_desc: 'Alle onderhoudswerkzaamheden moeten worden uitgevoerd volgens VCA-normen en bedrijfsveiligheidsprotocollen. Neem nooit risico\'s en werk altijd volgens de procedures.',
  
  maint_safe1: 'Spanning uitschakelen',
  maint_safe1_desc: 'Altijd eerst de spanning uitschakelen voordat u begint',
  maint_safe2: 'Lock-out/Tag-out',
  maint_safe2_desc: 'LOTO-procedure toepassen en vergrendelen',
  maint_safe3: 'PBM\'s dragen',
  maint_safe3_desc: 'Helm, veiligheidsbril, handschoenen en schoenen',
  maint_safe4: 'Risico\'s beoordelen',
  maint_safe4_desc: 'Werkplekinspectie en risicoanalyse uitvoeren',
  maint_safe5: 'Juiste gereedschappen',
  maint_safe5_desc: 'Alleen goedgekeurd en geschikt gereedschap gebruiken',
  maint_safe6: 'Brandveiligheid',
  maint_safe6_desc: 'Brandblusser beschikbaar en vluchtroutes vrij',
  maint_safe7: 'Machinebeveiliging',
  maint_safe7_desc: 'Beveiligingen respecteren en niet verwijderen',
  maint_safe8: 'Geen bypasses',
  maint_safe8_desc: 'Nooit veiligheidscircuits overbruggen',
  
  maint_problems_title: 'Veelvoorkomende problemen en oplossingen',
  
  maint_prob1: 'Versleten lagers',
  maint_prob1_sol: 'Lagers vervangen, oorzaak van slijtage onderzoeken (smering, belasting)',
  maint_prob2: 'Scheve transportband',
  maint_prob2_sol: 'Rollen uitlijnen, bandspanning controleren en aanpassen',
  maint_prob3: 'Defecte sensor',
  maint_prob3_sol: 'Sensor reinigen, afstelling controleren of sensor vervangen',
  maint_prob4: 'Kabelbreuk',
  maint_prob4_sol: 'Beschadigde kabel vervangen, bevestiging controleren',
  maint_prob5: 'Oververhitte motor',
  maint_prob5_sol: 'Koeling controleren, belasting verminderen, motor vervangen indien nodig',
  maint_prob6: 'Loszittende klemmen',
  maint_prob6_sol: 'Alle elektrische verbindingen controleren en vastdraaien',
  maint_prob7: 'Vervuiling in machine',
  maint_prob7_sol: 'Machine grondig reinigen, preventief schoonmaakschema opstellen',
  maint_prob8: 'Gebroken rollen',
  maint_prob8_sol: 'Defecte rollen vervangen, oorzaak van breuk onderzoeken',
  maint_prob9: 'Defecte inverter',
  maint_prob9_sol: 'Foutcodes uitlezen, parameters controleren of inverter vervangen',
  
  maint_problem: 'Probleem',
  maint_solution: 'Oplossing',
  maint_cause: 'Oorzaak',
  
  maint_cases_title: 'Praktijkvoorbeelden',
  maint_cases_desc: 'Echte situaties uit de praktijk met diagnose en oplossingen:',
  maint_click_details: 'Klik voor details',
  
  maint_case1_title: 'Motor start niet',
  maint_case1_problem: 'Een transportbandmotor reageert niet op het startsignaal. De PLC geeft geen foutmelding.',
  maint_case1_cause: 'Na controle blijkt de motorbeveiliging (thermisch relais) te zijn uitgeschakeld door overbelasting. De transportband was overbeladen met te zware pakketten.',
  maint_case1_solution: 'Thermisch relais resetten, belasting controleren en maximale belasting instellen. Preventief: gewichtslimiet communiceren en monitoren.',
  
  maint_case2_title: 'Transportband loopt scheef',
  maint_case2_problem: 'De transportband loopt steeds naar één kant en dreigt van de rollen af te lopen.',
  maint_case2_cause: 'De rollen zijn niet parallel gemonteerd en de bandspanning is ongelijk.',
  maint_case2_solution: 'Rollen uitlijnen met waterpas en laseruitlijnapparatuur. Bandspanning gelijkmatig instellen aan beide zijden. Band centreren en testrun uitvoeren.',
  
  maint_case3_title: 'Sensor geeft geen signaal',
  maint_case3_problem: 'Een foto-elektrische sensor detecteert geen pakketten meer. De LED op de sensor brandt niet.',
  maint_case3_cause: 'De sensorlens is vervuild door stof en de sensor is niet meer gevoelig genoeg.',
  maint_case3_solution: 'Sensor reinigen met geschikte reinigingsmiddelen. Detectieafstand controleren en opnieuw instellen. Preventief reinigingsschema opstellen.',
  
  maint_case4_title: 'PLC-storing: geen uitgang',
  maint_case4_problem: 'Een PLC-uitgang activeert een motor niet meer. De PLC-indicator brandt wel.',
  maint_case4_cause: 'De uitgangsmodule is defect door een kortsluiting in de bedrading.',
  maint_case4_solution: 'Kortsluiting in bedrading opsporen en repareren. Defecte uitgangsmodule vervangen. Bedrading controleren op beschadigingen en isolatie.',
  
  maint_summary_title: 'Samenvatting',
  
  maint_sum1: 'Onderhoudstechniek is essentieel voor betrouwbare en veilige werking van logistieke systemen',
  maint_sum2: 'Er zijn vier hoofdtypen onderhoud: preventief, correctief, predictief en periodiek',
  maint_sum3: 'Systematische diagnose helpt storingen snel en effectief op te lossen',
  maint_sum4: 'Veiligheid volgens VCA-normen heeft altijd absolute prioriteit',
  maint_sum5: 'Kennis van componenten en procedures is cruciaal voor professioneel onderhoud',
  maint_sum6: 'Goede documentatie en preventieve maatregelen voorkomen herhaling van problemen',
  
  maint_final_message: 'Professioneel onderhoud zorgt voor maximale uptime, veiligheid en efficiency in logistieke operaties!',

  // Quiz Logistiek
  quiz_logistiek_title: "Quiz – Logistieke Automatisering & Site Engineer",
  quiz_logistiek_intro: "Test je kennis over geautomatiseerde logistieke systemen, PLC's, sensoren, storingen en de rol van een Site Engineer. Deze uitgebreide quiz bevat 30 vragen over alle aspecten van moderne logistieke automatisering.",
  quiz_logistiek_instructions: "Beantwoord alle 30 vragen door het juiste antwoord (A, B of C) te selecteren. Je krijgt direct feedback over je score.",
  
  // Quiz Logistiek Questions
  quiz_logistiek_q1: "Wat is de hoofdfunctie van een PLC in logistieke automatisering?",
  quiz_logistiek_q1_a: "Alleen verlichting aansturen",
  quiz_logistiek_q1_b: "Sensoren uitlezen en motoren/actuatoren aansturen",
  quiz_logistiek_q1_c: "De transportband schoonmaken",

  quiz_logistiek_q2: "Welk bedrijf gebruikt GEEN geautomatiseerde sorteersystemen?",
  quiz_logistiek_q2_a: "Een kleine bakkerij",
  quiz_logistiek_q2_b: "PostNL",
  quiz_logistiek_q2_c: "DHL",

  quiz_logistiek_q3: "Wat gebeurt er als een fotocel (sensor) vervuild is?",
  quiz_logistiek_q3_a: "De motor draait sneller",
  quiz_logistiek_q3_b: "Er verandert niets",
  quiz_logistiek_q3_c: "Pakketten worden niet gedetecteerd",

  quiz_logistiek_q4: "Welk onderdeel zorgt voor de aandrijving van een transportband?",
  quiz_logistiek_q4_a: "Alleen de rollen",
  quiz_logistiek_q4_b: "Motor met tandwielkast",
  quiz_logistiek_q4_c: "Alleen de band zelf",

  quiz_logistiek_q5: "Wat betekent 'preventief onderhoud'?",
  quiz_logistiek_q5_a: "Onderhoud uitvoeren voordat er een storing optreedt",
  quiz_logistiek_q5_b: "Alleen repareren na een storing",
  quiz_logistiek_q5_c: "De machine nooit onderhouden",

  quiz_logistiek_q6: "Welke veiligheidsprocedure moet je ALTIJD toepassen voor onderhoud?",
  quiz_logistiek_q6_a: "Alleen handschoenen dragen",
  quiz_logistiek_q6_b: "Gewoon beginnen met werken",
  quiz_logistiek_q6_c: "Lock-out/Tag-out (LOTO) procedure",

  quiz_logistiek_q7: "Wat is een proximity sensor?",
  quiz_logistiek_q7_a: "Een sensor die geluid maakt",
  quiz_logistiek_q7_b: "Een sensor die metalen voorwerpen detecteert zonder contact",
  quiz_logistiek_q7_c: "Een sensor die alleen licht detecteert",

  quiz_logistiek_q8: "Welke spanning moet je EERST uitschakelen bij elektrisch onderhoud?",
  quiz_logistiek_q8_a: "De hoofdspanning (400V)",
  quiz_logistiek_q8_b: "Alleen de besturingsspanning (24V)",
  quiz_logistiek_q8_c: "Geen spanning uitschakelen",

  quiz_logistiek_q9: "Wat is de functie van lagers in een transportband?",
  quiz_logistiek_q9_a: "De band verwarmen",
  quiz_logistiek_q9_b: "Geluid maken",
  quiz_logistiek_q9_c: "Rollen soepel laten draaien met minimale wrijving",

  quiz_logistiek_q10: "Hoe herken je een defecte motor?",
  quiz_logistiek_q10_a: "Motor is koud",
  quiz_logistiek_q10_b: "Abnormale geluiden, oververhitting of niet starten",
  quiz_logistiek_q10_c: "Motor draait te langzaam",

  quiz_logistiek_q11: "Wat is correctief onderhoud?",
  quiz_logistiek_q11_a: "Reparaties uitvoeren nadat er een storing is opgetreden",
  quiz_logistiek_q11_b: "Alleen schoonmaken",
  quiz_logistiek_q11_c: "Preventief smeren",

  quiz_logistiek_q12: "Welke PBM's (Persoonlijke Beschermingsmiddelen) zijn verplicht in een logistiek centrum?",
  quiz_logistiek_q12_a: "Alleen handschoenen",
  quiz_logistiek_q12_b: "Alleen veiligheidsschoenen",
  quiz_logistiek_q12_c: "Veiligheidsschoenen, helm, veiligheidsbril en handschoenen",

  quiz_logistiek_q13: "Wat betekent een NO (Normally Open) contact?",
  quiz_logistiek_q13_a: "Contact is altijd gesloten",
  quiz_logistiek_q13_b: "Contact is open in ruststand, sluit bij activering",
  quiz_logistiek_q13_c: "Contact werkt niet",

  quiz_logistiek_q14: "Welke eerste stap neem je bij het diagnosticeren van een storing?",
  quiz_logistiek_q14_a: "Foutcodes lezen en visuele inspectie uitvoeren",
  quiz_logistiek_q14_b: "Direct onderdelen vervangen",
  quiz_logistiek_q14_c: "De machine opnieuw opstarten",

  quiz_logistiek_q15: "Wat is de functie van een barcode scanner in logistiek?",
  quiz_logistiek_q15_a: "Pakketten wegen",
  quiz_logistiek_q15_b: "Temperatuur meten",
  quiz_logistiek_q15_c: "Pakketinformatie lezen voor sortering en tracking",

  quiz_logistiek_q16: "Hoe vaak moet je lagers smeren?",
  quiz_logistiek_q16_a: "Nooit",
  quiz_logistiek_q16_b: "Volgens het onderhoudsschema (bijv. maandelijks)",
  quiz_logistiek_q16_c: "Alleen als ze kapot zijn",

  quiz_logistiek_q17: "Wat is de hoofdtaak van een Site Engineer?",
  quiz_logistiek_q17_a: "Storingen oplossen, proces bewaken en communicatie coördineren",
  quiz_logistiek_q17_b: "Alleen koffie drinken",
  quiz_logistiek_q17_c: "Alleen administratie doen",

  quiz_logistiek_q18: "Welke meting voer je uit om een kabelbreuk te vinden?",
  quiz_logistiek_q18_a: "Temperatuurmeting",
  quiz_logistiek_q18_b: "Gewichtsmeting",
  quiz_logistiek_q18_c: "Continuïteitsmeting (doormeten)",

  quiz_logistiek_q19: "Wat is een inverter (frequentieregelaar)?",
  quiz_logistiek_q19_a: "Een schakelaar",
  quiz_logistiek_q19_b: "Een apparaat dat motorsnelheid regelt door frequentie aan te passen",
  quiz_logistiek_q19_c: "Een lamp",

  quiz_logistiek_q20: "Welke werkwijze volg je bij een noodstop-activering?",
  quiz_logistiek_q20_a: "Oorzaak controleren, veiligheid waarborgen, dan reset uitvoeren",
  quiz_logistiek_q20_b: "Direct resetten zonder controle",
  quiz_logistiek_q20_c: "De noodstop negeren",

  quiz_logistiek_q21: "Wat is predictief onderhoud?",
  quiz_logistiek_q21_a: "Raden wanneer onderhoud nodig is",
  quiz_logistiek_q21_b: "Alleen visuele controle",
  quiz_logistiek_q21_c: "Onderhoud plannen op basis van sensordata en metingen",

  quiz_logistiek_q22: "Hoe test je of een sensor werkt?",
  quiz_logistiek_q22_a: "Alleen kijken",
  quiz_logistiek_q22_b: "Signaal meten met multimeter of PLC-status controleren",
  quiz_logistiek_q22_c: "Sensor vervangen",

  quiz_logistiek_q23: "Wat veroorzaakt meestal een scheve transportband?",
  quiz_logistiek_q23_a: "Verkeerd uitgelijnde rollen of ongelijke spanning",
  quiz_logistiek_q23_b: "Te veel pakketten",
  quiz_logistiek_q23_c: "Verkeerde kleur band",

  quiz_logistiek_q24: "Welke informatie vind je in een PLC-foutcode?",
  quiz_logistiek_q24_a: "Alleen de tijd",
  quiz_logistiek_q24_b: "Alleen de datum",
  quiz_logistiek_q24_c: "Type storing, locatie en mogelijke oorzaak",

  quiz_logistiek_q25: "Wat is de functie van een contactor?",
  quiz_logistiek_q25_a: "Geluid maken",
  quiz_logistiek_q25_b: "Elektrische circuits schakelen (aan/uit) op afstand",
  quiz_logistiek_q25_c: "Alleen verlichting dimmen",

  quiz_logistiek_q26: "Hoe voorkom je dat pakketten vastlopen op een transportband?",
  quiz_logistiek_q26_a: "Regelmatige inspectie, juiste afstelling en schoonhouden",
  quiz_logistiek_q26_b: "Harder duwen",
  quiz_logistiek_q26_c: "Meer pakketten erop leggen",

  quiz_logistiek_q27: "Wat betekent NC (Normally Closed) contact?",
  quiz_logistiek_q27_a: "Contact werkt niet",
  quiz_logistiek_q27_b: "Contact is altijd open",
  quiz_logistiek_q27_c: "Contact is gesloten in ruststand, opent bij activering",

  quiz_logistiek_q28: "Welke controle doe je na het vervangen van een transportband?",
  quiz_logistiek_q28_a: "Niets controleren",
  quiz_logistiek_q28_b: "Uitlijning, spanning en proefdraaien controleren",
  quiz_logistiek_q28_c: "Alleen de kleur controleren",

  quiz_logistiek_q29: "Wat is de belangrijkste regel bij ploegendienst als Site Engineer?",
  quiz_logistiek_q29_a: "Goede overdracht van informatie tussen ploegen",
  quiz_logistiek_q29_b: "Zo snel mogelijk naar huis gaan",
  quiz_logistiek_q29_c: "Alleen je eigen werk doen",

  quiz_logistiek_q30: "Welke meting verricht je om motorproblemen te diagnosticeren?",
  quiz_logistiek_q30_a: "Alleen naar de motor kijken",
  quiz_logistiek_q30_b: "Motor ruiken",
  quiz_logistiek_q30_c: "Spanning, stroom en isolatieweerstand meten",

  // Quiz feedback
  quiz_progress: "Voortgang",
  quiz_questions: "vragen",
  quiz_expert_level: "Expert Niveau Behaald!",
  quiz_expert_message: "Uitstekend! Je hebt een zeer goede kennis van logistieke automatisering en Site Engineer taken.",
  quiz_average: "Gemiddeld - meer studie aanbevolen",
};